/**
 * Land on #id after an in-app link: React Router does not scroll to a hash,
 * and ScrollManager opens a new page at its top and leaves the hash to the
 * page (2026-10-03: /chopshop#my-gallery, the editor's "Show me" after a
 * save, opened on the ChopBox with the gallery a screen below).
 *
 * Waits for the element (a signed-in page draws after the sign-in check), then
 * keeps it lined up while what is above it grows (a lazy editor, the casting
 * crew), until the visitor scrolls, taps or types, or `capMs` passes.
 * 'instant': html has scroll-behavior: smooth. Returns the cleanup.
 */
export function landOnHash(id: string, { capMs = 8000 }: { capMs?: number } = {}): () => void {
  const intents = ['wheel', 'touchstart', 'pointerdown', 'keydown'] as const;
  let alive = true;
  let frame = 0;
  let observer: ResizeObserver | null = null;
  const jump = (): boolean => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'instant', block: 'start' });
    return Boolean(el);
  };
  const stop = () => {
    if (!alive) return;
    alive = false;
    cancelAnimationFrame(frame);
    window.clearTimeout(cap);
    observer?.disconnect();
    intents.forEach((type) => window.removeEventListener(type, stop));
  };
  const first = () => {
    if (!alive) return;
    if (!jump()) frame = requestAnimationFrame(first);
  };
  const cap = window.setTimeout(stop, capMs);
  intents.forEach((type) => window.addEventListener(type, stop, { passive: true }));
  if (typeof ResizeObserver !== 'undefined') {
    observer = new ResizeObserver(() => { if (alive) jump(); });
    observer.observe(document.body);
  }
  first();
  return stop;
}
